import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import { get, includes, map, filter, isEmpty } from "lodash";

import Tabs from "@material-ui/core/Tabs";

import AddDetection from "./AddDetection";
import CustomTab from "../../Common/CustomTab";

import {
  human,
  driver,
  passenger,
  truck,
  trailer,
  trailer1,
  trailer2,
  logDetailsTabs,
  container1,
  container,
  container2,
} from "../../../constants/common";
import { driveInOut, walkInOut } from "../../../constants/reducers";

import { getAttributeValue } from "../../../utils/profile";

import { fetchTabData } from "../../../actions/siteEntranceExit/tabs";

import images from "../../../assets/img/images";

const styles = {
  tabs: {
    height: "40px",
    float: "left",
    minHeight: "40px",
  },
};

const LogDetailsTabs = (props) => {
  const {
    classes,
    section,
    log,
    tabValue,
    handleTabChange,
    overrides,
    getNotesCount,
  } = props;

  const getTabLabel = (type) => {
    if (includes([driver, passenger], type)) {
      const driveInEvent = get(
        filter(
          get(log, ["complete", "events"]),
          (e) =>
            includes([60, 61], get(e, ["type", "id"])) &&
            get(e, ["profile", "id"]) ===
              get(log, ["detections", type, "profile", "id"])
        ),
        [0]
      );
      const driverAttr = getAttributeValue(driveInEvent, 102);
      if (driverAttr === true) {
        return I18n.get("site_driver2");
      }
      if (driverAttr === false) {
        return I18n.get("site_passenger");
      }
      if (driverAttr === null) {
        return I18n.get("site_driver");
      }
    }
    return I18n.get(`site_${type}`);
  };

  return (
    <Tabs
      value={tabValue}
      onChange={handleTabChange}
      indicatorColor="primary"
      centered
      className={classes.tabs}
    >
      <CustomTab
        height="40px"
        label={I18n.get("site_summary")}
        value={logDetailsTabs.summary}
      />
      {section === driveInOut &&
        map(
          filter(
            [
              driver,
              passenger,
              truck,
              trailer1,
              trailer2,
              container1,
              container2,
            ],
            (type) => !isEmpty(get(log, ["detections", type]))
          ),
          (type) => (
            <CustomTab
              key={type}
              height="40px"
              label={getTabLabel(type)}
              value={type}
              icon={
                <img
                  src={
                    images[
                      `${
                        includes([driver, passenger], type)
                          ? human
                          : includes(type, trailer)
                          ? trailer
                          : includes(type, container)
                          ? container
                          : type
                      }IconBlack`
                    ]
                  }
                  height="17px"
                  style={{ maxWidth: "30px", paddingRight: "5px" }}
                  alt="icon"
                />
              }
              overridenIcon={get(overrides, [type])}
            />
          )
        )}
      {section === driveInOut && (
        <AddDetection
          dac={get(log, ["complete"])}
          section={section}
          refreshLogDetails={() => {
            props.dispatch(fetchTabData(section, props.tab));
            props.fetchChildrenEventGroups();
          }}
          siteId={get(log, ["main", "siteId"])}
          zoneId={get(log, ["main", "zoneId"])}
        />
      )}
      {section === walkInOut && (
        <CustomTab
          height="40px"
          label={I18n.get("site_human")}
          value={human}
          icon={
            <img
              src={images.humanIconBlack}
              height="17px"
              style={{ maxWidth: "30px", paddingRight: "5px" }}
              alt="icon"
            />
          }
          overridenIcon={get(overrides, [human])}
        />
      )}
      {section === walkInOut && (
        <CustomTab
          height="40px"
          label={I18n.get("site_verification")}
          value={logDetailsTabs.verification}
        />
      )}
      {section === walkInOut && (
        <CustomTab
          height="40px"
          label={I18n.get("site_temperatures")}
          value={logDetailsTabs.temperature}
        />
      )}
      <CustomTab
        height="40px"
        label={`${I18n.get("site_notes")} (${getNotesCount()})`}
        value={logDetailsTabs.notes}
      />
    </Tabs>
  );
};

export default connect()(withStyles(styles)(LogDetailsTabs));
